import { Box, Button, Typography } from "@mui/material";
import AppDialog from "components/common/AppDialog";
import type { PlatformDraftSummaryRow } from "userManagement/platformDraftsStorage";

interface UnsavedPlatformDraftsDialogProps {
  open: boolean;
  onClose: () => void;
  onDiscardAndContinue: () => void;
  title?: string;
  intro?: string;
  rows: PlatformDraftSummaryRow[];
  showWarning?: boolean;
  discardButtonLabel?: string;
}

export default function UnsavedPlatformDraftsDialog({
  open,
  onClose,
  onDiscardAndContinue,
  title = "Unsaved changes",
  intro = "You have unsaved changes. Discard them to continue or stay to keep editing.",
  rows,
  showWarning = true,
  discardButtonLabel = "Discard and continue",
}: UnsavedPlatformDraftsDialogProps) {
  return (
    <AppDialog
      open={open}
      onClose={onClose}
      title={title}
      maxWidth="sm"
      actions={
        <>
          <Button onClick={onClose} sx={{ textTransform: "none" }}>
            Stay
          </Button>
          <Button
            variant="contained"
            color="error"
            onClick={() => {
              onDiscardAndContinue();
            }}
            sx={{ textTransform: "none", fontWeight: 700 }}
          >
            {discardButtonLabel}
          </Button>
        </>
      }
    >
      {showWarning && (
        <Typography
          variant="subtitle2"
          fontWeight={800}
          sx={{ color: "error.main", textTransform: "uppercase", mb: 1.5 }}
        >
          Warning
        </Typography>
      )}
      <Typography variant="body2" sx={{ mb: 2 }}>
        {intro}
      </Typography>
      {rows.length > 0 && (
        <Box component="ul" sx={{ m: 0, pl: 2.5, "& li": { mb: 1.25 } }}>
          {rows.map((row) => (
            <Typography key={row.userId} variant="body2" component="li">
              <Box component="span" fontWeight={700}>
                {row.userLabel}
              </Box>
              {": "}
              {row.sections.join(", ")}
            </Typography>
          ))}
        </Box>
      )}
    </AppDialog>
  );
}
